import { z } from "zod";

import { baseApiResponse } from "./BaseApiResponse";

export const tournamentResolver = z.object({
	ID: z.number(),
	Name: z.string(),
	Description: z.string(),
	Image: z.string(),
	Selected: z.number(),
	Qualified: z.number(),
	WinnerBy: z.string(),
	PointsTotal: z.string(),
	PointsLimit: z.string().or(z.number()),
	FeeType: z.string(),
	FeeAmount: z.object({
		EUR: z.string(),
		Currency: z.string()
	}),
	Qualification: z.string(),
	BetMin: z.object({
		EUR: z.string()
	}),
	BetMax: z.object({
		EUR: z.string()
	}),
	Repeat: z.string(),
	Target: z.string(),
	Type: z.string(),
	Value: z.string(),
	Starts: z.string(),
	Ends: z.string(),
	Status: z.string(),
	RemainingTime: z.number(),
	CurrentTime: z.number(),
	TotalFounds: z.object({
		EUR: z.string(),
		Currency: z.string()
	}),
	WinningSpread: z.object({
		Percent: z.array(z.string()),
		EUR: z.array(z.number()),
		Currency: z.array(z.number())
	}),
	Terms: z.string()
});

export type TournamentModel = z.infer<typeof tournamentResolver>;

export const listTournamentsResponseResolver = baseApiResponse.extend({
	data: tournamentResolver.array()
});

export type ListTournamentsResponseModel = z.infer<typeof listTournamentsResponseResolver>;

export const joinTournamentResponseResolver = baseApiResponse.extend({
	data: z.object({
		Selected: z.number()
	})
});

export type JoinTournamentResponseModel = z.infer<typeof joinTournamentResponseResolver>;

const tournamentLeaderboardUserResolver = z.object({
	AddDate: z.string(),
	BestWinToBetRatio: z.string(),
	BetsAmount: z.string(),
	BetsAmountEUR: z.string(),
	BetsCount: z.string(),
	Currency: z.string(),
	EndDate: z.nullable(z.string()),
	ExRate: z.string(),
	FRPackagesUsed: z.string(),
	ID: z.string(),
	IDBonus: z.string(),
	IDLoyalty: z.string(),
	IDTournament: z.string(),
	IDUser: z.string(),
	IDWallet: z.string(),
	ManualPoints: z.string(),
	Place: z.nullable(z.string()),
	Points: z.number(),
	PointsCoef: z.string(),
	Qualification: z.string(),
	Status: z.string(),
	Win: z.nullable(z.string()),
	WinEUR: z.string(),
	WinsAmount: z.string(),
	WinsCount: z.string()
});

export type TournamentLeaderboardUserModel = z.infer<typeof tournamentLeaderboardUserResolver>;

const tournamentLeaderboardPlaceResolver = z.object({
	IDUserPlace: z.string(),
	IDUser: z.string(),
	Points: z.string(),
	Login: z.string(),
	FirstName: z.string(),
	LastName: z.string()
});

export type TournamentLeaderboardPlaceModel = z.infer<typeof tournamentLeaderboardPlaceResolver>;

export const getTournamentLeaderboardResponseResolver = baseApiResponse.extend({
	data: z.object({
		start: z.number(),
		limit: z.number(),
		results: tournamentLeaderboardPlaceResolver.array(),
		user: tournamentLeaderboardUserResolver.optional()
	})
});

export type GetTournamentLeaderboardResponseModel = z.infer<typeof getTournamentLeaderboardResponseResolver>;
